import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-analysis-column-molecule',
  templateUrl: './analysis-column-molecule.component.html',
  styleUrls: ['./analysis-column-molecule.component.scss']
})
export class AnalysisColumnMoleculeComponent {
  @Input() data: any;
  @Input() header: any;
  @Input() reportName: any;
  @Input() isOptionRequired: boolean;
  @Output() dataEmitForSalesEvent = new EventEmitter<{}>();
  skuLineGraphFlag: boolean = false;

  showMore(data, column?) {
    this.skuLineGraphFlag = this.isOptionRequired;
    if (this.skuLineGraphFlag) {
      this.dataEmitForSalesEvent.emit({ type: "sku", data: data });
    } else if (column) {
      this.dataEmitForSalesEvent.emit({ type: null, data: data });
    } else {
      this.dataEmitForSalesEvent.emit({ type: "product", data: data });
    }
  }
}
